import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "compliance-officer"
  }, [_c('tip'), _c('div', {
    staticClass: "status-tabs"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('状态')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "animated": false,
      "data-permission": "product_compliance_officer_search_audit_status",
      "id": "product_compliance_officer_search_audit_status",
      "activeKey": _vm.searchData.audit_status
    },
    on: {
      "change": _vm.complianceOfficerStatusChange
    }
  }, [_c('a-tab-pane', {
    key: _vm.$enum.product.MaintenanceProductStatusEnum.ALL
  }, [_c('div', {
    attrs: {
      "slot": "tab"
    },
    slot: "tab"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('全部')))]), _vm.searchData.audit_status === _vm.$enum.product.MaintenanceProductStatusEnum.ALL ? _c('span', [_vm._v("(" + _vm._s(_vm.total) + ")")]) : _vm._e()])]), _vm._l(_vm.maintenanceProductStatusEnum, function (item) {
    return _c('a-tab-pane', {
      key: item.value
    }, [_c('div', {
      attrs: {
        "slot": "tab"
      },
      slot: "tab"
    }, [_c('span', [_vm._v(_vm._s(item.text))]), _vm.searchData.audit_status === item.value ? _c('span', [_vm._v("(" + _vm._s(_vm.total) + ")")]) : _vm._e()])]);
  })], 2)], 1), _c('my-enter-search', {
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "product_compliance_officer_search_code_field",
      "id": "product_compliance_officer_search_code_field"
    },
    model: {
      value: _vm.searchData.code_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_field", $$v);
      },
      expression: "searchData.code_field"
    }
  }, _vm._l(_vm.maintenanceProductFieldEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "placeholder": _vm.t('双击可批量查询')
    },
    on: {
      "dblclick": _vm.handleDblClick
    },
    model: {
      value: _vm.docValue,
      callback: function ($$v) {
        _vm.docValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "docValue"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.product_name_lang,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_name_lang", $$v);
      },
      expression: "searchData.product_name_lang"
    }
  }, _vm._l(_vm.productNameLangEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u8BF7\u8F93\u5165"),
      "placeholder": _vm.t('请输入')
    },
    model: {
      value: _vm.searchData.product_name_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_name_value", $$v);
      },
      expression: "searchData.product_name_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u54C1\u7C7B"),
      "placeholder": _vm.t('商品品类'),
      "data-permission": "product_search_sort",
      "id": "product_search_sort",
      "show-search": "",
      "show-tip": ""
    },
    model: {
      value: _vm.searchData.category_id,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "category_id", $$v);
      },
      expression: "searchData.category_id"
    }
  }, _vm._l(_vm.productCateList, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5408\u89C4\u8D1F\u8D23\u4EBA\u540D\u79F0"),
      "show-tip": "",
      "allow-clear": false,
      "value": _vm.$enum.product.CompanyNameEnum.COMPANY,
      "placeholder": _vm.t('合规负责人名称')
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": _vm.$enum.product.CompanyNameEnum.COMPANY
    }
  }, [_vm._v(_vm._s(_vm.t('合规负责人名称')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u652F\u6301\u67E5\u8BE2\u591A\u79CD\u516C\u53F8\u540D\u79F0"),
      "data-permission": "product_compliance_officer_search_company",
      "id": "product_compliance_officer_search_company",
      "placeholder": _vm.t('支持查询多种公司名称')
    },
    model: {
      value: _vm.searchData.compliance_company_like,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "compliance_company_like", $$v);
      },
      expression: "searchData.compliance_company_like"
    }
  })], 1), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "bottom",
      "margin-top": "10px"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "product_maintenance_compliance_officer_search",
      "id": "product_maintenance_compliance_officer_search",
      "data-sign": "product_maintenance_compliance_officer_search",
      "loading": _vm.loadingStatus,
      "ghost": "",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "data-permission": "product_maintenance_compliance_officer_reset",
      "id": "product_maintenance_compliance_officer_reset",
      "data-sign": "product_maintenance_compliance_officer_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "box"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', '：')) + " " + _vm._s(this.selectedIdList.length) + " "), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'maintenance_compliance_officer_export',
      expression: "'maintenance_compliance_officer_export'"
    }],
    attrs: {
      "data-permission": "product_maintenance_compliance_officer_export",
      "id": "product_maintenance_compliance_officer_export"
    }
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-sign": "maintenance_compliance_officer_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": _vm.handleExportAll
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-sign": "maintenance_compliance_officer_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": _vm.handleExportSelected
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), [_vm.$enum.product.MaintenanceProductStatusEnum.WAITING_FOR_MAINTENANCE, _vm.$enum.product.MaintenanceProductStatusEnum.REJECT].includes(_vm.searchData.audit_status) ? _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'maintenance_compliance_officer_bulk',
      expression: "'maintenance_compliance_officer_bulk'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-permission": "product_maintenance_compliance_officer_bulk",
      "id": "product_maintenance_compliance_officer_bulk",
      "data-sign": "product_maintenance_compliance_officer_bulk",
      "fbu-analyse-name": $t("\u6279\u91CF\u7EF4\u62A4\u82F1\u56FD\u5408\u89C4\u8D1F\u8D23\u4EBA")
    },
    on: {
      "click": _vm.handleBatchAdd
    }
  }, [_vm._v(_vm._s(_vm.t('批量维护英国合规负责人')))]) : _vm._e(), _vm.searchData.audit_status === _vm.$enum.product.MaintenanceProductStatusEnum.MAINTENANCED ? _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-permission": "print_product_maintenance_compliance_officer_bulk",
      "id": "print_product_maintenance_compliance_officer_bulk",
      "data-sign": "print_product_maintenance_compliance_officer_bulk",
      "fbu-analyse-name": $t("\u6279\u91CF\u6253\u5370\u82F1\u56FD\u5408\u89C4\u8D1F\u8D23\u4EBA\u6807\u7B7E")
    },
    on: {
      "click": _vm.handleBatchPrint
    }
  }, [_vm._v(_vm._s(_vm.t('批量打印英国合规负责人标签')))]) : _vm._e()], 1)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext order-draft-table-box",
    attrs: {
      "bordered": "",
      "useMouseTool": "",
      "fixed-header": "",
      "is-filter-box": "",
      "data-sign": "product_maintenance_compliance_officer_list",
      "columns": _vm.columns,
      "data-source": _vm.data,
      "name": "maintenanceComponplianceOffcer",
      "row-key": "id",
      "row-selection": _vm.rowSelection
    },
    scopedSlots: _vm._u([{
      key: "product_sku",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('a', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.product_sku,
            expression: "record.product_sku"
          }],
          on: {
            "click": function () {
              return _vm.$router.push({
                name: 'ProductDetail',
                query: {
                  sku: record.product_sku
                },
                params: {
                  noCache: 1
                }
              });
            }
          }
        }, [_vm._v(" " + _vm._s(record.product_sku) + " ")])]);
      }
    }, {
      key: "import_country",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('span', [_vm._v(_vm._s(record.import_country) + "[" + _vm._s(record.import_country_name) + "]")])]);
      }
    }, {
      key: "compliance_officer_no",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(record.current_compliance_officer && record.current_compliance_officer.length ? record.current_compliance_officer[0].officer_no : '') + " ")]);
      }
    }, {
      key: "current_compliance_officer",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [record.current_compliance_officer && record.current_compliance_officer.length ? [record.compliance_leader_type !== _vm.$enum.product.COMPLIANCE_NAME_TYPE.MANUFACTURER_NAME ? _c('div', [_c('div', [_vm._v(" " + _vm._s(_vm.t('公司名称')) + _vm._s(_vm.tc('：')) + _vm._s(record.current_compliance_officer[0].company) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.t('公司地址')) + _vm._s(_vm.tc('：')) + _vm._s(_vm._f("filterEmpty")(record.current_compliance_officer[0].address)) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.t('电话')) + _vm._s(_vm.tc('：')) + _vm._s(_vm._f("filterEmpty")(record.current_compliance_officer[0].phone)) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.t('邮箱')) + _vm._s(_vm.tc('：')) + _vm._s(_vm._f("filterEmpty")(record.current_compliance_officer[0].mail)) + " ")])]) : _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])] : _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])], 2);
      }
    }, {
      key: "manufacturers_msg",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "width": "300px"
          }
        }, [record.current_compliance_officer ? [record.product_eu_uk_type === _vm.$enum.product.ComplianceProductTypeEnum.EU && record.compliance_leader_type ? _vm._l(record.current_compliance_officer, function (item, index) {
          return _c('div', {
            key: index,
            staticClass: "mb-10"
          }, [[record.compliance_leader_type === _vm.$enum.product.COMPLIANCE_NAME_TYPE.MANUFACTURER_NAME ? _c('div', [_vm._v(" " + _vm._s(_vm.t('【制造商】公司名称')) + _vm._s(_vm.tc('：')) + " "), _c('a', {
            directives: [{
              name: "copy2",
              rawName: "v-copy2",
              value: item.manufacturer_name,
              expression: "item.manufacturer_name"
            }],
            attrs: {
              "data-sign": "compliance_officer_detail"
            },
            on: {
              "click": function ($event) {
                return _vm.handleDetail(item);
              }
            }
          }, [_vm._v(_vm._s(_vm._f("filterEmpty")(item.manufacturer_name)))])]) : _c('div', [_vm._v(" " + _vm._s(_vm.t('【制造商】公司名称')) + _vm._s(_vm.tc('：')) + _vm._s(_vm._f("filterEmpty")(item.manufacturer_name)) + " ")])], _c('div', [_vm._v(" " + _vm._s(_vm.t('【制造商】公司地址')) + _vm._s(_vm.tc('：')) + _vm._s(_vm._f("filterEmpty")(item.manufacturer_address)) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.t('【制造商】电话')) + _vm._s(_vm.tc('：')) + _vm._s(_vm._f("filterEmpty")(item.manufacturer_phone)) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.t('【制造商】邮箱')) + _vm._s(_vm.tc('：')) + _vm._s(_vm._f("filterEmpty")(item.manufacturer_email)) + " ")])], 2);
        }) : _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])] : [_vm._v(_vm._s(_vm._f("filterEmpty")('')))]], 2);
      }
    }, {
      key: "audit_status_text",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "width": "160px"
          }
        }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(record.audit_status_text)) + " "), record.audit_status === _vm.$enum.product.MaintenanceProductStatusEnum.REJECT ? _c('a-tooltip', [_c('span', {
          attrs: {
            "slot": "title"
          },
          slot: "title"
        }, [_vm._v(_vm._s(_vm.t('驳回原因')) + _vm._s(_vm.tc('：')) + _vm._s(record.audit_remark))]), _c('a-icon', {
          style: {
            fontsize: '18px',
            color: '#FF7E00'
          },
          attrs: {
            "type": "exclamation-circle",
            "theme": "filled"
          }
        })], 1) : _vm._e()], 1);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [[_vm.$enum.product.MaintenanceProductStatusEnum.WAITING_FOR_MAINTENANCE].includes(record.audit_status) ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'maintenance_compliance_officer',
            expression: "'maintenance_compliance_officer'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "maintenance_compliance_officer",
            "id": "maintenance_compliance_officer",
            "data-sign": "maintenance_compliance_officer",
            "fbu-analyse-name": $t("\u7EF4\u62A4")
          },
          on: {
            "click": function ($event) {
              return _vm.handleAdd(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('维护')))]) : _vm._e(), [_vm.$enum.product.MaintenanceProductStatusEnum.MAINTENANCED, _vm.$enum.product.MaintenanceProductStatusEnum.REJECT].includes(record.audit_status) ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'maintenance_compliance_officer',
            expression: "'maintenance_compliance_officer'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "product_maintenance_compliance_officer_edit",
            "id": "product_maintenance_compliance_officer_edit",
            "data-sign": "product_maintenance_compliance_officer_edit",
            "fbu-analyse-name": $t("\u4FEE\u6539")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('修改')))]) : _vm._e(), [_vm.$enum.product.MaintenanceProductStatusEnum.MAINTENANCED].includes(record.audit_status) && record.import_country === _vm.$enum.common.CountryEnum.GB ? _c('a', {
          attrs: {
            "data-permission": "print_product_maintenance_compliance_officer_bulk",
            "id": "print_product_maintenance_compliance_officer_bulk",
            "data-sign": "print_product_maintenance_compliance_officer_bulk",
            "fbu-analyse-name": $t("\u6253\u5370\u82F1\u56FD\u5408\u89C4\u8D1F\u8D23\u4EBA\u6807\u7B7E")
          },
          on: {
            "click": function ($event) {
              return _vm.handlePrint(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('打印英国合规负责人标签')))]) : _vm._e()]);
      }
    }])
  })], 1), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "isFixed": "",
      "name": "maintenanceComponplianceOffcer",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  }), _c('batch-add-edit-modal', {
    attrs: {
      "visible": _vm.addEditVisible,
      "parentData": _vm.addEditData
    },
    on: {
      "success": _vm.handleSuccess,
      "update:visible": function ($event) {
        _vm.addEditVisible = $event;
      }
    }
  }), _c('detail-modal', {
    attrs: {
      "rowData": _vm.rowData,
      "visible": _vm.detailVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.detailVisible = $event;
      }
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };